// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth__Hooks from "./Auth__Hooks.res.js";
import * as SalesRoutes from "../../app/Sales/SalesRoutes.res.js";
import * as CustomerRoutes from "../../app/Customer/CustomerRoutes.res.js";
import * as SettingsRoutes from "../../app/Settings/SettingsRoutes.res.js";
import * as AnalyticsRoutes from "../../app/Analytics/AnalyticsRoutes.res.js";
import * as AccountingRoutes from "../../app/Accounting/AccountingRoutes.res.js";
import * as CashRegisterReportsRoutes from "../../app/CashRegisterReports/CashRegisterReportsRoutes.res.js";

let limitedUsers = [[
    "contact@malleval.com",
    {
      restrictedRoutes: [
        AnalyticsRoutes.baseRoute,
        SalesRoutes.baseRoute,
        CashRegisterReportsRoutes.baseRoute,
        AccountingRoutes.baseRoute,
        SettingsRoutes.baseRoute,
        CustomerRoutes.baseRoute
      ]
    }
  ]];

function useRole() {
  let match = Auth__Hooks.useState();
  if (typeof match !== "object") {
    return;
  }
  if (match.TAG === "Logging") {
    return;
  }
  let username = match._0.user.username;
  let match$1 = limitedUsers.find(param => param[0] === username);
  return match$1 !== undefined ? ({
      TAG: "LimitedUser",
      _0: match$1[1]
    }) : "Admin";
}

function isAuthorizedAccess(role, targetPathname) {
  if (typeof role === "object") {
    return role._0.restrictedRoutes.every(restrictedRoute => targetPathname.startsWith(restrictedRoute) === false);
  } else {
    return true;
  }
}

let cavavinCorporateNameRegex = /^witradis$/i;

let cavavinOrganizationNameRegex = /cavavin/i;

let cavavinMailDomainRegex = /^[a-zA-Z0-9._%+-]+@cavavin\.([a-z]{2})$/;

let winoMailDomainRegex = /^[a-zA-Z0-9._%+-]+@wino\.fr$/;

function hasCavavinPermission(username, organizationName, shops) {
  let shopsCorporateNameOk = shops.every(shop => cavavinCorporateNameRegex.test(shop.corporateName));
  let emailOk = cavavinMailDomainRegex.test(username);
  let cavavinOrganizationNameOk = cavavinOrganizationNameRegex.test(organizationName);
  let winoEmailOk = cavavinMailDomainRegex.test(username);
  if (shopsCorporateNameOk || emailOk || winoEmailOk) {
    return true;
  } else {
    return cavavinOrganizationNameOk;
  }
}

export {
  limitedUsers,
  useRole,
  isAuthorizedAccess,
  cavavinCorporateNameRegex,
  cavavinOrganizationNameRegex,
  cavavinMailDomainRegex,
  winoMailDomainRegex,
  hasCavavinPermission,
}
/* Auth__Hooks Not a pure module */
